export default function postAppMessage(kind, body) {
  const data = { kind }

  Object.assign(data, body)

  if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.appInterface) {
    window.webkit.messageHandlers.appInterface.postMessage(data)
  }

  if (window.appInterface) {
    window.appInterface.postMessage(JSON.stringify(data))
  }
}
